import React from 'react';

const Nav = (props) => {
    // If it's a dropdown item, render with different styling and support for icons
    if (props.isDropdownItem) {
        return (
            <a
                href="#"
                className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                onClick={(e) => {
                    e.preventDefault();
                    props.goToPage(props.route);
                }}
            >
                {props.icon && (
                    <svg className="w-5 h-5 mr-3 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {props.icon}
                    </svg>
                )}
                {props.name}
            </a>
        );
    }

    // Original button styling for regular nav items
    return (
        <button
            className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap ${
                props.curPath === props.route
                    ? 'text-blue-600 bg-blue-50'
                    : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
            }`}
            onClick={() => props.goToPage(props.route)}
        >
            {props.name}
        </button>
    );
};

export default Nav;
